export const EGG_GROUPS = {
  MONSTER: 1,
  WATER1: 2,
  BUG: 3,
  FLYING: 4,
  GROUND: 5,
  FAIRY: 6,
  PLANT: 7,
  HUMANSHAPE: 8,
  WATER3: 9,
  MINERAL: 10,
  INDETERMINATE: 11,
  WATER2: 12,
  DITTO: 13,
  DRAGON: 14,
  NO_EGGS: 15,
} as const;

export const GENDERS = {
  FEMALE: 1,
  MALE: 2,
  GENDERLESS: 3,
} as const;

export const GROWTH_RATES = {
  SLOW: 1,
  MEDIUM: 2,
  FAST: 3,
  MEDIUM_SLOW: 4,
  SLOW_THEN_VERY_FAST: 5,
  FAST_THEN_VERY_SLOW: 6,
} as const;

export const NATURES = {
  HARDY: 1,
  BOLD: 2,
  MODEST: 3,
  CALM: 4,
  TIMID: 5,
  LONELY: 6,
  DOCILE: 7,
  MILD: 8,
  GENTLE: 9,
  HASTY: 10,
  ADAMANT: 11,
  IMPISH: 12,
  BASHFUL: 13,
  CAREFUL: 14,
  RASH: 15,
  JOLLY: 16,
  NAUGHTY: 17,
  LAX: 18,
  QUIRKY: 19,
  NAIVE: 20,
  BRAVE: 21,
  RELAXED: 22,
  QUIET: 23,
  SASSY: 24,
  SERIOUS: 25,
} as const;

export const POKEATHLON_STATS = {
  SPEED: 1,
  POWER: 2,
  SKILL: 3,
  STAMINA: 4,
  JUMP: 5,
} as const;

export const POKEMON_COLORS = {
  BLACK: 1,
  BLUE: 2,
  BROWN: 3,
  GRAY: 4,
  GREEN: 5,
  PINK: 6,
  PURPLE: 7,
  RED: 8,
  WHITE: 9,
  YELLOW: 10,
} as const;

export const POKEMON_HABITATS = {
  CAVE: 1,
  FOREST: 2,
  GRASSLAND: 3,
  MOUNTAIN: 4,
  RARE: 5,
  ROUGH_TERRAIN: 6,
  SEA: 7,
  URBAN: 8,
  WATERS_EDGE: 9,
  /**
   * @deprecated Misspelled: the endpoint names this `mountain`.
   *   Use {@link POKEMON_HABITATS.MOUNTAIN}. Removed in 3.0.
   */
  MONTAIN: 4,
} as const;

export const POKEMON_SHAPES = {
  BALL: 1,
  SQUIGGLE: 2,
  FISH: 3,
  ARMS: 4,
  BLOB: 5,
  UPRIGHT: 6,
  LEGS: 7,
  QUADRUPED: 8,
  WINGS: 9,
  TENTACLES: 10,
  HEADS: 11,
  HUMANOID: 12,
  BUG_WINGS: 13,
  ARMOR: 14,
} as const;

export const STATS = {
  HP: 1,
  ATTACK: 2,
  DEFENSE: 3,
  SPECIAL_ATTACK: 4,
  SPECIAL_DEFENSE: 5,
  SPEED: 6,
  ACCURACY: 7,
  EVASION: 8,
  SPECIAL: 9,
} as const;

export const TYPES = {
  NORMAL: 1,
  FIGHTING: 2,
  FLYING: 3,
  POISON: 4,
  GROUND: 5,
  ROCK: 6,
  BUG: 7,
  GHOST: 8,
  STEEL: 9,
  FIRE: 10,
  WATER: 11,
  GRASS: 12,
  ELECTRIC: 13,
  PSYCHIC: 14,
  ICE: 15,
  DRAGON: 16,
  DARK: 17,
  FAIRY: 18,
  STELLAR: 19,
  UNKNOWN: 10_001,
  SHADOW: 10_002,
} as const;

/**
 * ## Type Name
 * A battle type as the PokéAPI names it, which is what a
 * `NamedAPIResource<Type>` carries and what the type chart is keyed by.
 *
 * The eighteen types a Pokémon can be, and `stellar`, which is a Tera type and
 * nothing else. `unknown` and `shadow` are in {@link TYPES} but not here: they
 * are artefacts of Generation II's internals and of Colosseum/XD, they appear in
 * no damage relation, and a table keyed by them would be a table with two entries
 * nothing can ever fill.
 *
 * Written out rather than derived from {@link TYPES}, for the same reason
 * `GenerationName` is: the set is closed, and the two exclusions are a decision
 * rather than a transformation.
 */
export type TypeName =
  | "normal"
  | "fighting"
  | "flying"
  | "poison"
  | "ground"
  | "rock"
  | "bug"
  | "ghost"
  | "steel"
  | "fire"
  | "water"
  | "grass"
  | "electric"
  | "psychic"
  | "ice"
  | "dragon"
  | "dark"
  | "fairy"
  | "stellar";
